module.exports = __webpack_public_path__ + "img/ba.d409a794.svg";